import { render, staticRenderFns } from "./CoronaArticle.vue?vue&type=template&id=22b615d4&"
import script from "./CoronaArticle.vue?vue&type=script&lang=js&"
export * from "./CoronaArticle.vue?vue&type=script&lang=js&"
import style0 from "./CoronaArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports